import 'project/css/main.css';
import { Mediator } from 'project/modules/mediator/mediator';

document.addEventListener('DOMContentLoaded', async () => {

	//version
	window.version = '?' + process.env.npm_package_version;
	//init
	await new Mediator().init();
});